import { Guid } from "guid-typescript";

import { ValidationIssueSeverity } from "infrastructure/validation";
import { extractApiErrorMessageContent } from "ui/shared/models/common";

import { IPlexTranslationUploadResponseItem } from "./PlexTranslationUpload.api";
import { IPlexTranslationUploadValidationIssue } from "./PlexTranslationUpload.state";

export const getValidationIssues = (response: IPlexTranslationUploadResponseItem[]): IPlexTranslationUploadValidationIssue[] => {
  return (
    response &&
    response.map<IPlexTranslationUploadValidationIssue>(e => {
      return {
        uniqueId: e.uniqueId ? e.uniqueId : Guid.raw(),
        messageId: e.messageId,
        messageTranslation: e.messageTranslation,
        locale: e.locale,
        industry: e.industry,
        validationIssue: {
          severity: ValidationIssueSeverity.Error,
          message: extractApiErrorMessageContent(e.error)
        }
      };
    })
  );
};
